module.exports = __webpack_public_path__ + "img/chat.b8dcf5e5.png";